var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"loader"}},[_c('br'),_c('br'),_c('div',{staticClass:"fa-3x spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_c('br')])
}]

export { render, staticRenderFns }